"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChipsInput = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _atoms = require("../../atoms");

var _index = require("../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const ChipsInput = props => {
  // eslint-disable-next-line no-unused-vars
  let lastEvent = null;
  const [value, setValue] = (0, _react.useState)(''); // eslint-disable-next-line no-unused-vars

  const [_chips, setChips] = (0, _react.useState)([]);
  const [chipSelected, setChipSelected] = (0, _react.useState)(false);
  const [isInputEnabled, setIsInputEnabled] = (0, _react.useState)('');
  const [isModalVisible, setModalVisible] = (0, _react.useState)(false);
  const chipsContainerRef = (0, _react.useRef)();
  const inputRef = (0, _react.useRef)();

  const onClick = () => {
    inputRef.current.focus();
  };

  const onBlur = () => {
    inputRef.current.blur();
  };

  const onFocus = () => {
    inputRef.current.focus();
  };

  const handleKeyDown = e => {
    if (e.keyCode === 13 && lastEvent === e) {
      lastEvent = null;
      return;
    }

    if (props.createChipKeys.includes(e.keyCode) || props.createChipKeys.includes(e.key)) {
      e.preventDefault();
      if (value.trim()) addChip(value);
    }

    if (e.keyCode === 8) {
      onBackspace();
    } else if (chipSelected) {
      setChipSelected(false);
    }
  };

  const onBackspace = () => {
    if (value === '' && props.value.length > 0) {
      // eslint-disable-next-line no-constant-condition
      if (chipSelected) {
        const nextChips = props.value.slice(0, -1);
        setChipSelected(false);
        setChips(nextChips);
        props.onChange(nextChips);
      } else {
        setChipSelected(true);
      }
    }
  };

  const addChip = value => {
    if (props.uniqueChips && props.value.indexOf(value) !== -1) {
      setValue(value);
      return;
    }

    let chips = [...props.value, value];
    props.onChange(chips);
    setValue('');
  };

  const removeChip = idx => () => {
    let left = props.value.slice(0, idx);
    let right = props.value.slice(idx + 1);
    const nextChips = [...left, ...right];
    props.onChange(nextChips);
    /*
    If remaining chips are less than minimum number of chips to show then
    hide modal as well because there is nothing to show in modal now
    */

    nextChips.length <= props.minimumChips && setModalVisible(false);
  };

  const viewMoreClickHandler = () => setModalVisible(true);

  const renderChips = () => {
    return props.value.map((chip, idx) => {
      // Show chips below threshold i.e, minimum num of chips to show, as they are.
      return idx + 1 <= props.minimumChips ? /*#__PURE__*/_react.default.cloneElement(props.renderChip(chip), {
        onRemove: removeChip(idx),
        // eslint-disable-next-line react/prop-types
        value: props.children,
        index: idx,
        key: `chip${idx}`
      }) : // Show first extra chips as "view more" button and ignore remaining ones
      idx + 1 === props.minimumChips + 1 && /*#__PURE__*/_react.default.createElement(_styles.StyledViewMoreButton, {
        onClick: viewMoreClickHandler,
        key: `chip${idx}`
      }, `+ View ${props.value.length - props.minimumChips} more`);
    });
  };

  const getExtraChips = () => {
    // This function will return all the remaining chips to show
    const extraChips = props.value.slice(props.minimumChips);
    const result = extraChips.map((chip, idx) => {
      return /*#__PURE__*/_react.default.cloneElement(props.renderChip(chip), {
        onRemove: removeChip(idx + props.minimumChips),
        // eslint-disable-next-line react/prop-types
        value: props.children,
        index: idx + props.minimumChips,
        key: `chip${idx + props.minimumChips}`
      });
    });
    return /*#__PURE__*/_react.default.createElement(_styles.StyledViewModalBody, null, result);
  };

  const handleClearChips = event => {
    event.stopPropagation();
    setIsInputEnabled(false);
    props.chipsClearHandler && props.chipsClearHandler(event);
  };

  const onChange = e => {
    if (e.target.value.indexOf(',') !== -1 && props.createChipKeys.includes(9)) {
      let chips = e.target.value.split(',').map(val => val.trim()).filter(val => val !== '');
      chips.forEach(chip => {
        addChip(chip);
      });
    } else {
      setValue(e.target.value);
    }
  };

  const {
    placeholder,
    label
  } = props;
  const inputProps = {
    placeholder,
    value,
    onChange,
    onKeyDown: handleKeyDown,
    onBlur,
    onFocus
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isModalVisible && /*#__PURE__*/_react.default.createElement(_index.Modal, {
    headerButtons: [],
    footerButtons: [{
      text: 'Close',
      isPrimary: false,
      onClick: () => setModalVisible(false)
    }],
    onClose: () => setModalVisible(false),
    onBackdropClick: () => setModalVisible(false),
    render: () => getExtraChips()
  }), /*#__PURE__*/_react.default.createElement(_styles.StyledInputChipsContainer, {
    ref: chipsContainerRef,
    className: "chipsContainer",
    chipsIn: props.value.length > 0 || isInputEnabled,
    onClick: () => {
      setIsInputEnabled(true);
      onClick();
    }
  }, /*#__PURE__*/_react.default.createElement(_styles.StyledChipsLabelWrapper, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "chips-label"
  }, label), props.showClearChipsButton && props.value.length > 0 && /*#__PURE__*/_react.default.createElement(_styles.StyledClearChipsIconWrapper, {
    className: "chips-clear-button"
  }, /*#__PURE__*/_react.default.createElement(_atoms.IconButton, {
    icon: "Close",
    isRounded: true,
    buttonSize: "24px",
    iconSize: 14,
    onClick: handleClearChips
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "chips-values-container"
  }, renderChips()), /*#__PURE__*/_react.default.createElement(_styles.StyledInput, _extends({}, inputProps, {
    ref: inputRef,
    isInputEnabled: isInputEnabled
  }))));
};

exports.ChipsInput = ChipsInput;
ChipsInput.propTypes = {
  /** A Field for Input Label*/
  label: _propTypes.default.string.isRequired,

  /** An array of data that represents the value of the chips */
  value: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,

  /** A function called when the value of chips changes, passes the chips value as an argument. */
  onChange: _propTypes.default.func,

  /** A filed for input Chips placeholder */
  placeholder: _propTypes.default.string,

  /** A filed for unique chips */
  uniqueChips: _propTypes.default.bool,

  /** For custom chip usage. A function that passes the value of the chip as an argument, must return an element that will be rendered as each chip. */
  renderChip: _propTypes.default.func,

  /** For custom chip key number in array */
  createChipKeys: _propTypes.default.array,

  /** Minimum number of chips to render before grouping them to 'view more' button */
  minimumChips: _propTypes.default.number,

  /** Show/Hide clear button to deselect all selected chips */
  showClearChipsButton: _propTypes.default.bool,

  /** Function to clear all the selected chips */
  chipsClearHandler: _propTypes.default.func
};
ChipsInput.defaultProps = {
  label: 'Input Chips',
  placeholder: '',
  createChipKeys: [9],
  uniqueChips: true,
  value: [],
  onChange: () => {},
  renderChip: (value, customTheme) => /*#__PURE__*/_react.default.createElement(_atoms.Chip, {
    theme: customTheme,
    className: "input-chip"
  }, value),
  getChipValue: item => item,
  minimumChips: 5
};